import { Modal, Tab } from 'bootstrap';

import app from 'Shared/app';
import ds from 'Shared/ds';

export default class Consent {
    constructor() {
        if (document.getElementById("cookie-consent")) {
            this.#modal.show();
        }
    }

    preferences = ko.observable(false);
    statistics = ko.observable(false);
    marketing = ko.observable(false);

    get #container() {
        return document.getElementById("cookie-consent");
    }

    get #tab() {
        return this.#container.getElementById("consent-tab");
    }
    
    get #modal() {
        return Modal.getOrCreateInstance(this.#container);
    }

    showDetails() {
        const triggerEl = document.querySelector('#consent-tab button[data-bs-target="#cookies-details"]')
        Tab.getOrCreateInstance(triggerEl).show();
    }

    async accept() {
        await this.consent();
    }
    
    async acceptAll() {
        this.preferences(true);
        this.statistics(true);
        this.marketing(true);

        await this.consent();
    }

    async consent() {
        var data = {
            necessary: true,
            preferences: this.preferences(),
            statistics: this.statistics(),
            marketing: this.marketing()
        }

        await ds.post("/common/cookieConsent", data);

        app.reloadPage();
    }
}